// extracted by mini-css-extract-plugin
export default {"trainAwsPdApplication":"styles_trainAwsPdApplication__KSTWq","iframeContainer":"styles_iframeContainer__dwZRS"};